const FloatingLabelTextarea = ({ label, value, onChange, error, disabled }) => {
    return (
      <div className="input-wrapper">
        <textarea
          className={`input-field ${error ? 'error' : ''}`}
          value={value}
          onChange={onChange}
          placeholder=" "
          disabled={disabled}
          rows={10}
          style={{fontFamily: "montserrat"}}
        />
        <label className="input-label">{label}</label>
      </div>
    );
  };
  
  export default FloatingLabelTextarea;
  